var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{ 'active': _vm.isActive }},[_c('app-link',{attrs:{"to":_vm.item.path}},[(_vm.item.meta.icon)?_c('svg-icon',{attrs:{"icon-class":_vm.item.meta.icon}}):_vm._e(),_c('span',{staticClass:"text-overflow"},[_vm._v(_vm._s(_vm.item.meta.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }